import { useState, useEffect } from 'react';

export default function ArrivalCurtain({ onComplete }) {
  const [phase, setPhase] = useState(0);
  const [isReturn, setIsReturn] = useState(false);
  const [storedName, setStoredName] = useState('');

  useEffect(() => {
    const visited = localStorage.getItem('at_has_visited');
    const profile = localStorage.getItem('at_fan_profile');
    if (visited) {
      setIsReturn(true);
      try { const p = JSON.parse(profile); if (p?.insideData?.name) setStoredName(p.insideData.name); } catch {}
      // Quick welcome for return visitors
      setPhase(1);
      const t1 = setTimeout(() => setPhase(2), 2000);
      const t2 = setTimeout(() => { setPhase(3); onComplete(); }, 2800);
      return () => { clearTimeout(t1); clearTimeout(t2); };
    } else {
      localStorage.setItem('at_has_visited', 'true');
      // Full arrival for first-time
      const t1 = setTimeout(() => setPhase(1), 200);
      const t2 = setTimeout(() => setPhase(2), 800);
      const t3 = setTimeout(() => setPhase(3), 1200);
      const t4 = setTimeout(() => setPhase(4), 1600);
      const t5 = setTimeout(() => setPhase(5), 2200);
      const t6 = setTimeout(() => setPhase(6), 3000);
      const t7 = setTimeout(() => { setPhase(7); onComplete(); }, 3800);
      return () => { [t1,t2,t3,t4,t5,t6,t7].forEach(clearTimeout); };
    }
  }, [onComplete]);

  if ((!isReturn && phase >= 7) || (isReturn && phase >= 3)) return null;

  // Return visitor — quick welcome
  if (isReturn) {
    return (
      <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center" style={{ background: 'var(--deep-black)', opacity: phase >= 2 ? 0 : 1, transition: 'opacity 0.8s var(--ease-out-expo)' }}>
        <p className="font-['Playfair_Display'] italic text-3xl md:text-4xl" style={{ color: 'var(--gold)', opacity: phase >= 1 ? 1 : 0, transition: 'opacity 0.6s ease' }}>
          {storedName ? `Welcome back, ${storedName}.` : 'Welcome back.'}
        </p>
      </div>
    );
  }

  // First visit — full arrival
  return (
    <div
      data-testid="arrival-curtain"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center"
      style={{ background: 'var(--deep-black)', opacity: phase >= 6 ? 0 : 1, transition: 'opacity 0.8s var(--ease-out-expo)' }}
    >
      <div className="relative flex flex-col items-center">
        <div className="mb-4" style={{ height: '1px', background: 'var(--gold)', opacity: phase >= 2 ? 0 : 0.6, width: phase >= 1 ? '120px' : '0', transition: 'width 0.6s var(--ease-out-expo), opacity 0.3s ease 0.5s' }} />

        <div className="flex items-baseline" style={{ lineHeight: 0.85 }}>
          <span className="font-['Playfair_Display'] italic font-normal text-[22vw] md:text-[15vw] lg:text-[11vw]" style={{ color: 'var(--gold)', opacity: phase >= 2 ? 1 : 0, transform: phase >= 2 ? 'translateY(0) scale(1)' : 'translateY(10px) scale(0.95)', filter: phase >= 2 ? 'blur(0)' : 'blur(4px)', transition: 'all 0.7s var(--ease-out-expo)', textShadow: phase >= 4 ? '0 0 40px rgba(201,168,76,0.5), 0 0 80px rgba(201,168,76,0.2)' : '0 0 0 transparent' }}>A</span>
          <span className="font-['Playfair_Display'] italic font-normal text-[22vw] md:text-[15vw] lg:text-[11vw]" style={{ color: 'var(--gold)', opacity: phase >= 3 ? 1 : 0, transform: phase >= 3 ? 'translateY(0) scale(1)' : 'translateY(10px) scale(0.95)', filter: phase >= 3 ? 'blur(0)' : 'blur(4px)', transition: 'all 0.7s var(--ease-out-expo)', textShadow: phase >= 4 ? '0 0 40px rgba(201,168,76,0.5), 0 0 80px rgba(201,168,76,0.2)' : '0 0 0 transparent' }}>T</span>
          <span className="font-['Playfair_Display'] italic font-normal text-[22vw] md:text-[15vw] lg:text-[11vw] at-shimmer-dot" style={{ opacity: phase >= 4 ? 1 : 0, transform: phase >= 4 ? 'scale(1)' : 'scale(0)', transition: 'all 0.5s var(--ease-out-expo)' }}>.</span>
        </div>

        <div className="absolute inset-0 pointer-events-none" style={{ background: phase >= 4 ? 'radial-gradient(ellipse at center, rgba(201,168,76,0.08) 0%, transparent 70%)' : 'transparent', transition: 'background 1s ease' }} />

        <p className="font-['Cormorant_Garamond'] text-sm md:text-base tracking-[0.3em] uppercase mt-6" style={{ color: 'var(--ash)', opacity: phase >= 5 ? 1 : 0, transform: phase >= 5 ? 'translateY(0)' : 'translateY(8px)', transition: 'all 0.6s var(--ease-out-expo)' }}>
          Avinash Tiwary
        </p>
      </div>
    </div>
  );
}
